<template>
  <div class="form-field" :rel="name"
       v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm, 'form-readonly': readOnly, 'has-lang': lang, 'form-focus': focus, 'form-disabled':isDisabled}">
    <div class="form-label" v-show="label">{{ label }}</div>
    <div class="form-hint" v-show="hint">{{ hint }}</div>
    <div class="form-input">
      <div style="display: flex; flex-direction: row" class="form-input-wrapper">
        <input type="text"
               v-bind:style="width?'width:'+width+'px':''"
               value="" v-model="internalValue"
               :placeholder="placeholder"
               :readonly="readOnly"
               :disabled="isDisabled"
               :maxlength="maxlength"
               @focus="focus=true"
               @blur="focus=false"
               v-on:keyup.enter="onKeyEnterCallback(internalValue)"/>
        <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
        <div class="form-translations" v-if="translations && Object.keys(translations).length > 1">
          <Translator @updateValue="updateValue" :translate-key="translateKey" :lang="lang" v-model="translations" />
          <i :class="langClass"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
        </div>
        <span v-for="item in action">
          <button @click="item.callback(internalValue)" class="btn"><span>{{ item.label }}</span></button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Translator from "./Translator.vue";
import ModalLang from './ModalLang.vue'
import OrderService from "../../modules/shop/order/OrderService";
export default {
  name: 'FormField',
  components: {Translator},
  props: ['value', 'label', 'hint', 'translateKey', 'name', 'placeholder', 'suffix', 'lang', 'required', 'readonly', 'maxlength', 'disabled', 'width', 'translations', 'action', 'onKeyEnter'],
  data: function () {
    return {
      internalValue: '',
      isModalVisible: false,
      langClass: "",
      focus: false,
      orderSelection: {
        data: {
          ids: [],
          status: {},
          has_notification: false
        }
      }
    }
  },
  created: function () {
    this.internalValue = this.value;
    this.langClass = this.lang ? "flag lang-" + this.lang : "";
    this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
    this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
    this.setDisabled(this.disabled)
  },
  methods: {
    onKeyEnterCallback: function(value)
    {
      if( this.onKeyEnter )
      {
        this.onKeyEnter(value);
      }
      return false;
    },
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    },
    updateValue: function (val) {
      this.internalValue = val
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'value'(newVal, oldVal) {
      this.internalValue = newVal
    },
    'internalValue'(newVal, oldVal) {
      this.$emit('input', this.internalValue);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/Text.vue